interface ConditionalRendererProps {
    if: any;
    renderer: Function;
}

export let ConditionalRenderer = function (props: ConditionalRendererProps) {
    if (props.if) {
        return props.renderer()
    }

    return null;
};
